import {
  Alert,
  Box,
  Button,
  CardContent,
  LinearProgress,
  List,
  ListItemButton,
  ListItemText,
  Popover,
  Snackbar,
  Typography
} from '@mui/material';
import {
  keywordOverviewCss,
  KeywordOverviewResultCardsCss,
  snackBar
} from '../keywordResearch/keywordOverview/keywordOverviewCSS';
import { MapRankCss } from './MapRankCss';
import { MapRankTexts } from './MapRankTexts';
import { KeywordTrackingResultCss } from '../keywordResearch/keywordTracking/KeywordTrackingAllCss';
import { CustomTooltip } from '../keywordResearch/CustomTooltip';
import { keywordResearchDashBoardCss } from '../keywordResearch/keywordResearchCSS';
import HelpIcon from '@mui/icons-material/Help';
import { LocalRankingMap } from './LocalRankingMap';
import { useEffect, useRef, useState } from 'react';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import {
  exportCsvIcon,
  websiteAuditDashboardText
} from 'src/common/config/TextMessage';
import {
  setGetReportDetails,
  setMapRankSection,
  setSelectedMapKeyword
} from 'src/redux/localSeo';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import CommonModal from 'src/common/config/CommonModal';
import { LoaderModal } from '../localSeo/LoaderModal';
import { getReportDetail } from 'src/common/Scraper';
import { LocalSeoAllSx } from '../localSeo/localSeoCss';
import {
  getLocalSeoId,
  removeNegativeSign
} from 'src/common/config/FunctionHelperPartTwo';
import { API } from 'src/common/config/API';
import {
  getCookie,
  timeConverter,
  firstWordCapital
} from 'src/common/config/FunctionHelper';
import axios from 'axios';
import { GenerateIdeasLoader } from '../keywordResearch/blogPostIdeas/GenerateIdeasLoader';

export const MapRankResultCards = ({
  reportData,
  mapDashboard = null,
  isExporting = false,
  isPdfBuilder = false
}) => {
  const getReportDetails: any =
    useSelector((state: RootState) => state.localSeo.getReportDetails) ?? null;
  const [anchorElGrid, setAnchorElGrid] = useState(null);
  const [selectedValueGrid, setSelectedValueGrid] = useState<any>(
    isPdfBuilder
      ? reportData?.keywords?.[0] || null
      : getReportDetails?.keywords?.[0] || null
  );

  const createMapData: any =
    useSelector((state: RootState) => state.localSeo.createMapData) ?? null;

  let selectedBusinessName: any =
    useSelector((state: RootState) => state.localSeo.selectedBusinessName) ??
    '';

  let reduxFilteredLocationsData: any =
    useSelector(
      (state: RootState) => state.localSeo.reduxFilteredLocationsData
    ) ?? null;
  let userDetails: any = useSelector(
    (state: RootState) => state?.counter?.userDetails
  );
  const locationId = getLocalSeoId();

  let match = reduxFilteredLocationsData?.find((location) =>
    locationId
      ? location?.name === locationId
      : location?.title === selectedBusinessName
  );
  const [loading, setLoading] = useState(null);
  const [error, setError]: any = useState(false);
  const [optionsGrid, setOptionsGrid]: any = useState([]);
  const [exportPDFLoading, setExportPDFLoading] = useState(null);
  const [showPDFSnackBar, setShowPDFSnackBar] = useState(null);

  const keywordBoxRef = useRef(null);
  const dispatch = useDispatch();

  useEffect(() => {
    if (isPdfBuilder) {
      if (reportData?.keywords?.[0]) {
        setSelectedValueGrid(reportData.keywords[0]);
      }
      return;
    }

    const firstKeyword = getReportDetails?.keywords?.[0];
    if (firstKeyword) {
      if (!selectedValueGrid) {
        setSelectedValueGrid(firstKeyword);
        dispatch(setSelectedMapKeyword(firstKeyword));
      } else {
        const keywordExists = getReportDetails?.keywords?.some(
          (k: any) => k.id === selectedValueGrid.id
        );
        if (!keywordExists) {
          // If report changed and current selection is not in the new reports keywords, reset to first
          setSelectedValueGrid(firstKeyword);
          dispatch(setSelectedMapKeyword(firstKeyword));
        } else {
          dispatch(setSelectedMapKeyword(selectedValueGrid));
        }
      }
    }
  }, [getReportDetails, dispatch, selectedValueGrid, isPdfBuilder, reportData]);

  useEffect(() => {

    const data = getReportDetails?.keywords || [];

    setOptionsGrid(data);
  }, [match, getReportDetails]);

  const openGrid = Boolean(anchorElGrid);
  const idGrid = openGrid ? 'area-popover' : undefined;

  const handleClickGrid = (event) => {
    setAnchorElGrid(event.currentTarget);
  };

  const handleCloseGrid = () => {
    setAnchorElGrid(null);
  };

  const handleSelectGrid = (value) => {
    setSelectedValueGrid(value);
    dispatch(setSelectedMapKeyword(value));
    // In PDF builder (preview or export), we never call getReportDetail
    if (!isExporting && !isPdfBuilder) {
      getReportDetailResponse(value?.id);
    }
    handleCloseGrid();
  };
  const summary = reportData?.summary || {};
  const totalPoints = summary?.num_points || 0;
  const gridPoints = reportData?.grid_points ?? [];

  const isValidRank = (rank: any) => typeof rank === 'number' && rank >= 1;

  const count_1_to_3 = Array.isArray(gridPoints)
    ? gridPoints?.filter((p) => isValidRank(p?.rank) && p?.rank <= 3)?.length
    : 0;

  const count_4_to_9 = Array.isArray(gridPoints)
    ? gridPoints?.filter(
        (p) => isValidRank(p?.rank) && p?.rank >= 4 && p?.rank <= 9
      )?.length
    : 0;

  const count_10_plus = Array.isArray(gridPoints)
    ? gridPoints?.filter((p) => isValidRank(p?.rank) && p.rank >= 10)?.length
    : 0;

  const ratingData = [
    {
      value: 'Position 1-3',
      per:
        totalPoints > 0 ? ((count_1_to_3 / totalPoints) * 100).toFixed(0) : '0',
      bg: '#D1F5EE',
      count: count_1_to_3 || '0'
    },
    {
      value: 'Position 4-9',
      per:
        totalPoints > 0 ? ((count_4_to_9 / totalPoints) * 100).toFixed(0) : '0',
      bg: '#FFEAD5',
      count: count_4_to_9 || '0'
    },
    {
      value: 'Position 10+',
      per:
        totalPoints > 0
          ? ((count_10_plus / totalPoints) * 100).toFixed(0)
          : '0',
      bg: '#FEE4E2',
      count: count_10_plus || '0'
    }
  ];
  const getReportDetailResponse = async (id = null) => {
    if (isExporting || isPdfBuilder) return;
    setLoading(true);
    const payload = {
      report_id: getReportDetails?.mapRankerDetail?.report_id
        ? getReportDetails?.mapRankerDetail?.report_id
        : mapDashboard && match?.reportId
        ? match?.reportId
        : createMapData?.reportId,
      location_id: getReportDetails?.mapRankerDetail?.locationId
        ? getReportDetails?.mapRankerDetail?.locationId
        : mapDashboard && match?.locationId
        ? match?.locationId
        : createMapData?.locationId,
      keyword_id: id || null
    };
    const response: any = await getReportDetail(payload);

    if (response?.progressing === false) {
      dispatch(setGetReportDetails(response));
      setTimeout(() => {
        dispatch(setMapRankSection(1));
      }, 1000);
    } else {
      dispatch(setGetReportDetails(response));
      setError(response);
      setTimeout(() => {
        setError(null);
      }, 5000);
    }
    setLoading(null);
  };
  const handleCloseBackLinkSnackBar = () => {
    setError(null);
  };

  /**
   * Exports the Map Rank report as a PDF file by calling the backend API.
   * Downloads the PDF using a blob and extracted headers for filename.
   *
   * Steps:
   * 1. Sends payload with report details to backend.
   * 2. Receives PDF file as blob (binary data).
   * 3. Extracts content-type and filename from headers.
   * 4. Triggers a file download using anchor tag and blob.
   * 5. Shows success/error snackbar message accordingly.
   */
  const exportAsPDF = async () => {
    if (exportPDFLoading) {
      return;
    }

    // Show loader on button or UI
    setExportPDFLoading(true);

    let currentDate = '';

    try {
      const now = Date.now(); // milliseconds
      currentDate = timeConverter(
        now,
        userDetails?.date_format || 'DD/MM/YYYY'
      );
    } catch (error) {
      console.error('Error formatting current date:', error);
      currentDate = 'Date unavailable';
    }

    // Construct the payload using dynamic report and keyword values
    const payload = {
      runId: getReportDetails?.mapRankerDetail?.run_id,
      reportId: getReportDetails?.mapRankerDetail?.report_id,
      keywordId: selectedValueGrid?.id || null,
      currentDate,
      runComparison: getReportDetails?.runComparison || null
    };

    try {
      let tokenStr = getCookie(process.env.REACT_APP_COOKIE_NAME);
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/${API.EndPoint.generateMapRankPdf}`,
        payload,
        {
          responseType: 'blob', // Required for binary file (PDF)
          withCredentials: true // Important: send cookies automatically

        }
      );

      // Extract content type and file extension
      const contentType = response.headers['content-type'];
      const ext = contentType === 'application/pdf' ? '.pdf' : '.bin';

      // Extract filename from headers
      const contentDisposition = response.headers['content-disposition'];
      const filename =
        contentDisposition?.split('filename=')?.[1]?.replace(/"/g, '') ||
        `map_rank_export${ext}`;

      // Create Blob for download
      const blob = new Blob([response.data], { type: contentType });

      // Generate temporary download link
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);

      // Show success snackbar
      setShowPDFSnackBar({
        status: 'success',
        message: 'PDF exported successfully.'
      });
    } catch (err) {
      console.error('Export failed:', err);
      setShowPDFSnackBar({
        status: 'error',
        message: 'Failed to export PDF.'
      });
    } finally {
      setExportPDFLoading(false);
      setTimeout(() => {
        setShowPDFSnackBar(null);
      }, 5000);
    }
  };

  const handleClosePDFSnackBar = () => {
    setShowPDFSnackBar(null);
  };

  const getCompareScoreJSX = (comparisonScore) => {
    if (
      comparisonScore === 0 ||
      isNaN(comparisonScore) ||
      comparisonScore === null
    ) {
      return null;
    }
    if (Math.sign(comparisonScore) === 1) {
      return (
        <Box
          sx={{
            //marginTop: '38px',
            marginTop: '16px',
            ...MapRankCss?.iconBoxCss
          }}
        >
          <img src="/static/images/icons/local-seo/green_up.svg" alt="icon" />
          <Typography
            sx={{
              ...LocalSeoAllSx?.perSx,
              fontSize: '16px',
              color: '#1A927B'
            }}
          >
            {removeNegativeSign(comparisonScore)}%
          </Typography>
        </Box>
      );
    } else if (Math.sign(comparisonScore) === -1) {
      return (
        <Box
          sx={{
            //marginTop: '38px',
            marginTop: '16px',
            ...MapRankCss?.iconBoxCss
          }}
        >
          <img src="/static/images/icons/local-seo/red_down.svg" alt="icon" />
          <Typography
            sx={{
              ...LocalSeoAllSx?.perSx,
              fontSize: '16px',
              color: '#D92D20'
            }}
          >
            {removeNegativeSign(comparisonScore)}%
          </Typography>
        </Box>
      );
    }
  };

  return (
    <>
      {showPDFSnackBar?.status && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={showPDFSnackBar?.status}
          autoHideDuration={5000}
          onClose={handleClosePDFSnackBar}
        >
          <Box>
            <Alert
              icon={
                showPDFSnackBar?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleClosePDFSnackBar}
              severity={showPDFSnackBar?.status}
              variant="filled"
              sx={{
                ...(showPDFSnackBar?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  showPDFSnackBar?.status === 'success'
                    ? 'rgba(235, 255, 250, 1)'
                    : '#FEE4E2',
                border:
                  showPDFSnackBar?.status === 'success'
                    ? '1px solid #87DCB8'
                    : '1px solid #F04438',
                maxWidth: '667px'
              }}
            >
              {showPDFSnackBar?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {error?.status && (
        <Snackbar
          sx={{ marginTop: '2.8rem' }}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right'
          }}
          open={error?.status}
          autoHideDuration={5000}
          onClose={handleCloseBackLinkSnackBar}
        >
          <Box>
            <Alert
              icon={
                error?.status === 'success' ? (
                  <img
                    draggable={false}
                    src={
                      process.env.PUBLIC_URL +
                      `/static/images/icons/checkIcon.svg`
                    }
                    style={{
                      width: '40px',
                      height: '27px'
                    }}
                  />
                ) : undefined // fallback to default icon
              }
              onClose={handleCloseBackLinkSnackBar}
              severity={error?.status}
              variant="filled"
              sx={{
                ...(error?.status === 'success'
                  ? snackBar?.alert
                  : snackBar?.alertError),
                backgroundColor:
                  error?.status === 'success'
                    ? 'rgba(235, 255, 250, 1)'
                    : '#FEE4E2',
                border:
                  error?.status === 'success'
                    ? '1px solid #87DCB8'
                    : '1px solid #F04438',
                maxWidth: '667px'
              }}
            >
              {error?.message}
            </Alert>
          </Box>
        </Snackbar>
      )}
      {!mapDashboard ? (
        <Box
          sx={{
            ...(isExporting
              ? { border: 'none', boxShadow: 'none', px: 0, py: 0 }
              : keywordOverviewCss?.card)
          }}
        >
          <CardContent
            sx={{
              paddingBottom: '0px !important',
              ...keywordOverviewCss?.cardContent
            }}
          >
            {!mapDashboard && (
              <Box sx={keywordOverviewCss?.analyzePreviousBox}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  <Typography sx={MapRankCss?.keywordTrackingTextSx}>
                    {MapRankTexts?.mapAnalyzeTitle}
                  </Typography>
                  <CustomTooltip
                    title={
                      <Box>
                        <Typography
                          sx={keywordResearchDashBoardCss?.customTollTipText}
                        >
                          {MapRankTexts?.mapAnalyzeTooltipTitle}
                        </Typography>
                      </Box>
                    }
                    placement="bottom"
                    arrow
                  >
                    <HelpIcon
                      sx={KeywordOverviewResultCardsCss?.helpIcon}
                      className="ml-2"
                    />
                  </CustomTooltip>
                </Box>
                <Box sx={MapRankCss?.startBtnBoxSx}>
                  <Button
                    sx={keywordOverviewCss?.previousSearchesBtn}
                    variant="outlined"
                    onClick={() => {
                      dispatch(setMapRankSection(3));
                    }}
                  >
                    <Typography sx={keywordOverviewCss?.previousSearchesText}>
                      {MapRankTexts?.previousSearch}
                    </Typography>
                  </Button>
                  <Button
                    sx={keywordOverviewCss?.previousSearchesBtn}
                    variant="contained"
                    onClick={() => {
                      dispatch(setMapRankSection(0));
                    }}
                  >
                    <Typography sx={MapRankCss?.startNewText}>
                      {MapRankTexts?.startNewText}
                    </Typography>
                  </Button>
                </Box>
              </Box>
            )}
            <Box
              sx={{
                marginTop: isPdfBuilder || isExporting ? '0px' : '24px',
                display: 'flex',
                alignItems: 'end',
                gap: '12px'
              }}
            >
              <Box className="LocalSeoKeywordSelector" sx={{ width: '100%' }}>
                {isPdfBuilder ? (
                  <Typography
                    sx={{
                      fontFamily: 'Inter',
                      fontWeight: 700,
                      fontSize: '16px',
                      color: '#120242',
                      marginBottom: '12px'
                    }}
                  >
                    Keyword:{' '}
                    <span style={{ fontWeight: 400 }}>
                      {firstWordCapital(
                        selectedValueGrid?.name ||
                          selectedValueGrid?.keyword ||
                          reportData?.keywords?.[0]?.name ||
                          reportData?.keywords?.[0]?.keyword ||
                          'N/A'
                      )}
                    </span>
                  </Typography>
                ) : (
                  <>
                    <Typography
                      sx={{
                        marginBottom: '6px',
                        ...MapRankCss?.analyzeFieldsLabel
                      }}
                    >
                      {MapRankTexts?.showResultsFor}
                    </Typography>
                    <Box
                      ref={keywordBoxRef}
                      onClick={handleClickGrid}
                      sx={{
                        width: '100%',
                        ...MapRankCss?.popoverBoxSx,
                        cursor: isExporting ? 'default' : 'pointer',
                        pointerEvents: isExporting ? 'none' : 'auto'
                      }}
                    >
                      <Typography sx={MapRankCss?.popoverNewSelectSx}>
                        {selectedValueGrid?.name}
                      </Typography>
                      {!isExporting &&
                        (openGrid ? (
                          <ExpandLess sx={MapRankCss?.popoverIcon} />
                        ) : (
                          <ExpandMore sx={MapRankCss?.popoverIcon} />
                        ))}
                    </Box>
                  </>
                )}

                <Popover
                  id={idGrid}
                  open={openGrid}
                  anchorEl={anchorElGrid}
                  onClose={handleCloseGrid}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                  }}
                  disableScrollLock={true}
                  PaperProps={{
                    sx: {
                      ...MapRankCss?.popoverPaperProp,
                      minWidth: keywordBoxRef.current?.clientWidth || 240,
                      borderRadius: '8px'
                    }
                  }}
                >
                  <List sx={{ padding: 0 }}>
                    {optionsGrid?.map((option) => (
                      <ListItemButton
                        key={option?.id}
                        onClick={() => handleSelectGrid(option)}
                        sx={MapRankCss?.popoverListItemBtn}
                      >
                        <ListItemText
                          primary={firstWordCapital(option?.name || '')}
                          primaryTypographyProps={
                            MapRankCss?.popoverNewSelectSx
                          }
                        />
                      </ListItemButton>
                    ))}
                  </List>
                </Popover>
              </Box>
              {!isExporting && (
                <Box
                  sx={{
                    position: 'relative',
                    display: 'inline-block'
                  }}
                >
                  <Button
                    startIcon={
                      <img
                        src={process.env.PUBLIC_URL + exportCsvIcon}
                        alt="csv icon"
                        draggable={false}
                      />
                    }
                    variant="outlined"
                    sx={{
                      minWidth: '186px',
                      maxHeight: '44px',
                      borderRadius: '6px',
                      padding: '10px 16px 10px 16px',
                      border: '1px solid #A09DAB'
                    }}
                    onClick={exportAsPDF}
                  >
                    <Typography
                      sx={{
                        fontFamily: 'Inter',
                        fontWeight: 600,
                        fontSize: '14px',
                        lineHeight: '20px'
                      }}
                    >
                      {MapRankTexts?.exportAsPNG}
                    </Typography>
                  </Button>
                </Box>
              )}
            </Box>
            <Box
              className="LocalSeoMetricsGrid"
              sx={MapRankCss?.keywordNewCardMainSx}
            >
              <Box
                className="LocalSeoMetricCard"
                sx={{
                  ...MapRankCss?.cardExtraCss,
                  ...MapRankCss?.keywordCardSubSx
                }}
              >
                <Box
                  sx={{
                    ...KeywordTrackingResultCss?.subBoxHeader
                  }}
                >
                  <Typography
                    className="LocalSeoMetricTitle"
                    sx={MapRankCss?.overviewCardTitleSx}
                  >
                    {MapRankTexts?.averageMapRank}
                  </Typography>
                  <CustomTooltip
                    title={
                      <Box>
                        <Typography
                          sx={keywordResearchDashBoardCss?.customTollTipText}
                        >
                          {MapRankTexts?.averageMapRankTooltip}
                        </Typography>
                      </Box>
                    }
                    placement="bottom"
                    arrow
                  >
                    <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                  </CustomTooltip>
                </Box>
                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                  <Typography
                    className="LocalSeoMetricValue"
                    sx={MapRankCss?.overviewNewCardValueSx}
                  >
                    {reportData?.summary?.avg_rank >= 0
                      ? reportData?.summary?.avg_rank
                      : 0}
                  </Typography>
                  {getCompareScoreJSX(
                    parseFloat(
                      isPdfBuilder
                        ? reportData?.runComparison?.avg_rank_change ?? 0
                        : getReportDetails?.runComparison?.avg_rank_change ?? 0
                    )
                  )}
                </Box>
              </Box>
              <Box
                className="LocalSeoMetricCard"
                sx={{
                  ...MapRankCss?.cardExtraCss,
                  ...MapRankCss?.keywordCardSubSx
                }}
              >
                <Box
                  sx={{
                    ...KeywordTrackingResultCss?.subBoxHeader
                  }}
                >
                  <Typography
                    className="LocalSeoMetricTitle"
                    sx={MapRankCss?.overviewCardTitleSx}
                  >
                    {MapRankTexts?.visibility}
                  </Typography>
                  <CustomTooltip
                    title={
                      <Box>
                        <Typography
                          sx={keywordResearchDashBoardCss?.customTollTipText}
                        >
                          {MapRankTexts?.visibilityTooltip}
                        </Typography>
                      </Box>
                    }
                    placement="bottom"
                    arrow
                  >
                    <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                  </CustomTooltip>
                </Box>
                <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                  <Typography
                    className="LocalSeoMetricValue"
                    sx={MapRankCss?.overviewNewCardValueSx}
                  >
                    {reportData?.visibility || reportData?.visibility === 0
                      ? `${reportData?.visibility}%`
                      : ''}
                  </Typography>
                  {getCompareScoreJSX(
                    parseFloat(
                      isPdfBuilder
                        ? reportData?.runComparison?.visibility_change ?? 0
                        : getReportDetails?.runComparison?.visibility_change ??
                            0
                    )
                  )}
                </Box>
              </Box>
              <Box
                className="LocalSeoMetricCard"
                sx={{
                  ...MapRankCss?.cardExtraCss,
                  ...MapRankCss?.keywordCardSubSx
                }}
              >
                {ratingData?.map((item, idx) => (
                  <Box key={idx} sx={MapRankCss?.ratingBoxSx}>
                    <Typography
                      className="LocalSeoMetricRowTitle"
                      sx={MapRankCss?.ratingTitle}
                    >
                      {item?.value}
                    </Typography>
                    <LinearProgress
                      variant="determinate"
                      value={item?.per ? parseFloat(item?.per) : 0}
                      sx={{
                        ...MapRankCss?.ratingProgressSx,
                        bgcolor: item?.bg
                      }}
                      color={
                        item?.value === 'Position 1-3'
                          ? 'secondary'
                          : item?.value === 'Position 4-9'
                          ? 'info'
                          : 'error'
                      }
                    />
                    <Typography
                      className="LocalSeoMetricRowValue"
                      sx={MapRankCss?.ratingPerSx}
                    >
                      {item?.count || 0}
                    </Typography>
                  </Box>
                ))}
              </Box>
            </Box>
            <LocalRankingMap
              reportData={reportData}
              isExporting={isExporting}
              isPdfBuilder={isPdfBuilder}
            />
          </CardContent>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              marginTop: isPdfBuilder || isExporting ? '0px' : '24px',
              display: 'flex',
              alignItems: 'end',
              gap: '12px'
            }}
          >
            <Box className="LocalSeoKeywordSelector" sx={{ width: '100%' }}>
              <Typography
                sx={{
                  marginBottom: '6px',
                  ...MapRankCss?.analyzeFieldsLabel
                }}
              >
                {MapRankTexts?.showResultsFor}
              </Typography>
              <Box
                ref={keywordBoxRef}
                onClick={handleClickGrid}
                sx={{
                  width: '100%',
                  ...MapRankCss?.popoverBoxSx,
                  cursor: isExporting ? 'default' : 'pointer',
                  pointerEvents: isExporting ? 'none' : 'auto'
                }}
              >
                <Typography sx={MapRankCss?.popoverNewSelectSx}>
                  {selectedValueGrid?.name}
                </Typography>
                {!isExporting &&
                  (openGrid ? (
                    <ExpandLess sx={MapRankCss?.popoverIcon} />
                  ) : (
                    <ExpandMore sx={MapRankCss?.popoverIcon} />
                  ))}
              </Box>

              <Popover
                id={idGrid}
                open={openGrid}
                anchorEl={anchorElGrid}
                onClose={handleCloseGrid}
                anchorOrigin={{
                  vertical: 'bottom',
                  horizontal: 'left'
                }}
                disableScrollLock={true}
                PaperProps={{
                  sx: {
                    ...MapRankCss?.popoverPaperProp,
                    minWidth: keywordBoxRef.current?.clientWidth || 240,
                    borderRadius: '8px'
                  }
                }}
              >
                <List sx={{ padding: 0 }}>
                  {optionsGrid?.map((option) => (
                    <ListItemButton
                      key={option?.id}
                      onClick={() => handleSelectGrid(option)}
                      sx={MapRankCss?.popoverListItemBtn}
                    >
                      <ListItemText
                        primary={option?.name}
                        primaryTypographyProps={MapRankCss?.popoverNewSelectSx}
                      />
                    </ListItemButton>
                  ))}
                </List>
              </Popover>
            </Box>
            <Box
              sx={{
                position: 'relative',
                display: 'inline-block'
              }}
            >
              <Button
                startIcon={
                  <img
                    src={process.env.PUBLIC_URL + exportCsvIcon}
                    alt="csv icon"
                    draggable={false}
                  />
                }
                variant="outlined"
                sx={{
                  minWidth: '186px',
                  maxHeight: '44px',
                  borderRadius: '6px',
                  padding: '10px 16px 10px 16px',
                  border: '1px solid #A09DAB'
                }}
                onClick={exportAsPDF}
              >
                <Typography
                  sx={{
                    fontFamily: 'Inter',
                    fontWeight: 600,
                    fontSize: '14px',
                    lineHeight: '20px'
                  }}
                >
                  {MapRankTexts?.exportAsPNG}
                </Typography>
              </Button>
            </Box>
          </Box>
          <Box
            className="LocalSeoMetricsGrid"
            sx={MapRankCss?.keywordNewCardMainSx}
          >
            <Box
              className="LocalSeoMetricCard"
              sx={{
                ...MapRankCss?.cardExtraCss,
                ...MapRankCss?.keywordCardSubSx
              }}
            >
              <Box
                sx={{
                  ...KeywordTrackingResultCss?.subBoxHeader
                }}
              >
                <Typography
                  className="LocalSeoMetricTitle"
                  sx={MapRankCss?.overviewCardTitleSx}
                >
                  {MapRankTexts?.averageMapRank}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        {MapRankTexts?.averageMapRankTooltip}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                <Typography
                  className="LocalSeoMetricValue"
                  sx={MapRankCss?.overviewNewCardValueSx}
                >
                  {reportData?.summary?.avg_rank >= 0
                    ? reportData?.summary?.avg_rank
                    : 0}
                </Typography>
                {getCompareScoreJSX(
                  parseFloat(
                    isPdfBuilder
                      ? reportData?.runComparison?.avg_rank_change ?? 0
                      : getReportDetails?.runComparison?.avg_rank_change ?? 0
                  )
                )}
              </Box>
            </Box>
            <Box
              className="LocalSeoMetricCard"
              sx={{
                ...MapRankCss?.cardExtraCss,
                ...MapRankCss?.keywordCardSubSx
              }}
            >
              <Box
                sx={{
                  ...KeywordTrackingResultCss?.subBoxHeader
                }}
              >
                <Typography
                  className="LocalSeoMetricTitle"
                  sx={MapRankCss?.overviewCardTitleSx}
                >
                  {MapRankTexts?.visibility}
                </Typography>
                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        {MapRankTexts?.visibilityTooltip}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                  arrow
                >
                  <HelpIcon sx={KeywordOverviewResultCardsCss?.helpIcon} />
                </CustomTooltip>
              </Box>
              <Box display={'flex'} alignItems={'center'} gap={'8px'}>
                <Typography
                  className="LocalSeoMetricValue"
                  sx={MapRankCss?.overviewNewCardValueSx}
                >
                  {reportData?.visibility || reportData?.visibility === 0
                    ? `${reportData?.visibility}%`
                    : ''}
                </Typography>
                {getCompareScoreJSX(
                  parseFloat(
                    isPdfBuilder
                      ? reportData?.runComparison?.visibility_change ?? 0
                      : getReportDetails?.runComparison?.visibility_change ?? 0
                  )
                )}
              </Box>
            </Box>
            <Box
              className="LocalSeoMetricCard"
              sx={{
                ...MapRankCss?.cardExtraCss,
                ...MapRankCss?.keywordCardSubSx
              }}
            >
              {ratingData?.map((item, idx) => (
                <Box key={idx} sx={MapRankCss?.ratingBoxSx}>
                  <Typography
                    className="LocalSeoMetricRowTitle"
                    sx={MapRankCss?.ratingTitle}
                  >
                    {item?.value}
                  </Typography>
                  <LinearProgress
                    variant="determinate"
                    value={item?.per ? parseFloat(item?.per) : 0}
                    sx={{
                      ...MapRankCss?.ratingProgressSx,
                      bgcolor: item?.bg
                    }}
                    color={
                      item?.value === 'Position 1-3'
                        ? 'secondary'
                        : item?.value === 'Position 4-9'
                        ? 'info'
                        : 'error'
                    }
                  />
                  <Typography
                    className="LocalSeoMetricRowValue"
                    sx={MapRankCss?.ratingPerSx}
                  >
                    {item?.count || 0}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
          <LocalRankingMap
            reportData={reportData}
            isExporting={isExporting}
            isPdfBuilder={isPdfBuilder}
          />
        </>
      )}

      <CommonModal
        open={exportPDFLoading}
        handCloseModal={() => {}}
        title={''}
        closebtn={false}
        blur={false}
        isBuySearchCredit={false}
      >
        <GenerateIdeasLoader
          title={websiteAuditDashboardText?.pdfGeneratingText}
          isPdf={false}
          isPdfLoader={true}
        ></GenerateIdeasLoader>
      </CommonModal>
      <CommonModal
        open={loading}
        handCloseModal={() => {}}
        title={''}
        closebtn={false}
        isAgencyModal={true}
        isInfoModal={true}
        isFreeDowngrade={true}
        isDynamicWidth={'610px'}
      >
        <LoaderModal />
      </CommonModal>
    </>
  );
};
